"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewEmote = void 0;
const validation_1 = require("../../validation");
var PreviewEmote;
(function (PreviewEmote) {
    PreviewEmote["IDLE"] = "idle";
    PreviewEmote["WALK"] = "walk";
    PreviewEmote["RUN"] = "run";
    PreviewEmote["JUMP"] = "jump";
    PreviewEmote["CLAP"] = "clap";
    PreviewEmote["DAB"] = "dab";
    PreviewEmote["DANCE"] = "dance";
    PreviewEmote["FASHION"] = "fashion";
    PreviewEmote["FASHION_2"] = "fashion-2";
    PreviewEmote["FASHION_3"] = "fashion-3";
    PreviewEmote["FASHION_4"] = "fashion-4";
    PreviewEmote["LOVE"] = "love";
    PreviewEmote["MONEY"] = "money";
    PreviewEmote["FIST_PUMP"] = "fist-pump";
    PreviewEmote["HEAD_EXPLODE"] = "head-explode";
    PreviewEmote["WAVE"] = "wave";
})(PreviewEmote = exports.PreviewEmote || (exports.PreviewEmote = {}));
/** @alpha */
(function (PreviewEmote) {
    PreviewEmote.schema = {
        type: 'string',
        enum: Object.values(PreviewEmote)
    };
    PreviewEmote.validate = (0, validation_1.generateLazyValidator)(PreviewEmote.schema);
})(PreviewEmote = exports.PreviewEmote || (exports.PreviewEmote = {}));
//# sourceMappingURL=preview-emote.js.map